<template>
  <v-card>
    <v-card-title class="headline grey lighten-2" primary-title>
      Match Later with
      <v-spacer></v-spacer>
      <v-btn text icon @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-container fluid grid-list-sm>
        <v-layout row wrap>
          <v-flex xs12>
            <v-text-field
              v-model="matchLaterForm.docNo"
              :label="matchLaterLabel.docNo"
              :error-messages="errors.collect('docNo')"
              data-vv-name="docNo"
              :data-vv-as="matchLaterLabel.docNo"
            >
              <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                <v-icon color="info" @click="showDocNoHelpList = true" v-text="'mdi-magnify'"></v-icon>
              </v-slide-x-reverse-transition>
            </v-text-field>
          </v-flex>
          <v-flex xs12 v-if="tranType === 'Y'">
            <v-subheader class="queryLabel">{{ matchLaterLabel.or }}</v-subheader>
          </v-flex>
          <v-flex xs12 v-if="tranType === 'Y'">
            <v-text-field
              v-model="matchLaterForm.coverNote"
              :label="matchLaterLabel.coverNote"
              :error-messages="errors.collect('coverNote')"
              data-vv-name="coverNote"
              :data-vv-as="matchLaterLabel.coverNote"
            >
              <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                <v-icon color="info" @click="showCoverNoteNoList = true" v-text="'mdi-magnify'" :disabled="tranType !== 'Y'"></v-icon>
              </v-slide-x-reverse-transition>
            </v-text-field>
          </v-flex>
          <v-flex xs12 v-if="tranType === 'Y'">
            <v-subheader class="queryLabel">{{ matchLaterLabel.or }}</v-subheader>
          </v-flex>
          <v-flex xs12 v-if="tranType === 'Y'">
            <v-text-field
              v-model="matchLaterForm.vehRegNo"
              :label="matchLaterLabel.vehRegNo"
              :error-messages="errors.collect('vehRegNo')"
              data-vv-name="vehRegNo"
              :data-vv-as="matchLaterLabel.vehRegNo"
            >
              <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                <v-icon color="info" @click="showVehRegNoList = true" v-text="'mdi-magnify'" :disabled="tranType !== 'Y'"></v-icon>
              </v-slide-x-reverse-transition>
            </v-text-field>
          </v-flex>
          <v-flex xs12 v-if="tranType === 'Y'">
            <v-subheader class="queryLabel">{{ matchLaterLabel.or }}</v-subheader>
          </v-flex>
          <v-flex xs12 v-if="tranType === 'Y'">
            <v-text-field
              v-model="matchLaterForm.polNo"
              :label="matchLaterLabel.polNo"
              :error-messages="errors.collect('polNo')"
              data-vv-name="polNo"
              :data-vv-as="matchLaterLabel.polNo"
              v-validate="checkPolicy"
              hint="Policy format: Policy No-RenCnt-EndtCnt"
            >
              <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                <v-icon color="info" @click="showPolNoList = true" v-text="'mdi-magnify'" :disabled="tranType !== 'Y'"></v-icon>
              </v-slide-x-reverse-transition>
            </v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-actions right>
      <v-spacer></v-spacer>
      <v-btn color="primary" dark @click.prevent="doSubmit"> Submit </v-btn>
    </v-card-actions>
    <v-dialog v-model="showDocNoHelpList" width="1280px">
      <doc-no-help-list
        callerPage="MatchLater"
        :multiFundSfxCurr="multiFundSfxCurr"
        :curr="curr"
        :accountNo="acctNo"
        :fund="fund"
        :acctNoSfx="acctNoSfx"
        :boolRefresh="showDocNoHelpList"
        @close="showDocNoHelpList = false"
        @assign-doc-no-info="assignDocNoInfo"
      ></doc-no-help-list>
    </v-dialog>
    <v-dialog v-model="showCoverNoteNoList" width="1280px">
      <cover-note-help-list
        callerPage="MatchLater"
        :multiFundSfxCurr="multiFundSfxCurr"
        :curr="curr"
        :accountNo="acctNo"
        :fund="fund"
        :acctNoSfx="acctNoSfx"
        :boolRefresh="showCoverNoteNoList"
        @close="showCoverNoteNoList = false"
        @assign-cover-note-info="assignCoverNoteInfo"
      ></cover-note-help-list>
    </v-dialog>
    <v-dialog v-model="showVehRegNoList" width="1280px">
      <veh-reg-help-list
        callerPage="MatchLater"
        :multiFundSfxCurr="multiFundSfxCurr"
        :curr="curr"
        :accountNo="acctNo"
        :fund="fund"
        :acctNoSfx="acctNoSfx"
        :boolRefresh="showVehRegNoList"
        @close="showVehRegNoList = false"
        @assign-veh-reg-info="assignVehRegInfo"
      ></veh-reg-help-list>
    </v-dialog>
    <v-dialog v-model="showPolNoList" width="1280px">
      <acct-policy-help-list
        callerPage="MatchLater"
        :multiFundSfxCurr="multiFundSfxCurr"
        :curr="curr"
        :accountNo="acctNo"
        :fund="fund"
        :acctNoSfx="acctNoSfx"
        :boolPolRefresh="showPolNoList"
        @close="showPolNoList = false"
        @assign-policy-info="assignPoNoInfo"
      ></acct-policy-help-list>
    </v-dialog>
    <v-dialog v-model="promptWarning" width="50%" persistent>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-card-title class="headline grey lighten-2" primary-title>
              Warning
              <v-spacer></v-spacer>
              <v-btn text icon @click="closeWarningDialog">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-container fluid grid-list-sm>
                <v-layout row wrap>
                  <v-flex xs12>
                    {{ promptWarnMsg }}
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-dialog>
  </v-card>
</template>

<script>
import DocNoHelpList from '../../common/dialog/DocNoHelpList'
import CoverNoteHelpList from '../../common/dialog/CoverNoteHelpList'
import VehRegHelpList from '../../common/dialog/VehRegHelpList'
import AcctPolicyHelpList from '../../common/dialog/AcctPolicyHelpList'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'

export default {
  data() {
    return {
      matchLaterLabel: {
        docNo: 'This Document',
        coverNote: 'This Cover Note',
        vehRegNo: 'This Vehicle Registration No.',
        polNo: 'This Policy No.',
        or: 'OR'
      },
      matchLaterForm: {
        docNo: '',
        bmDocNo: '',
        bmBrn: '',
        bmTranType: '',
        bmFund: '',
        bmAcctNoSfx: '',
        bmAcctNo: '',
        coverNote: '',
        vehRegNo: '',
        polNo: '',
        renCnt: '',
        endtCnt: '',
        fullName: '',
        address1: '',
        address2: '',
        address3: '',
        address4: '',
        postalCode: '',
        insuredName: '',
        insdRefNo: ''
      },
      showDocNoHelpList: false,
      showCoverNoteNoList: false,
      showVehRegNoList: false,
      showPolNoList: false,
      promptWarning: false,
      promptWarnMsg: ''
    }
  },
  mounted() {
    this.doInit()
  },
  methods: {
    doInit() {
      var thisForm = this.matchLaterForm
      Object.keys(this.matchLaterForm).forEach(function (key, index) {
        thisForm[key] = ''
      })
      if (this.polNo !== null) {
        this.matchLaterForm.polNo = this.polNo
      }
      this.promptWarnMsg = ''
    },
    doSubmit() {
      if (
        this.matchLaterForm.docNo !== '' ||
        this.matchLaterForm.coverNote !== '' ||
        this.matchLaterForm.vehRegNo !== '' ||
        this.matchLaterForm.polNo !== ''
      ) {
        if (this.matchLaterForm.docNo !== '' && (this.matchLaterForm.coverNote !== '' || this.matchLaterForm.vehRegNo !== '')) {
          this.promptWarnMsg = 'Only allowed to enter Document No. or Cover Note or Vehicle Registration No. '
          this.promptWarning = true
        } else {
          this.$emit('assign-match-later-info', this.matchLaterForm)
        }
      } else {
        this.promptWarnMsg = 'Must enter a valid value in the field'
        this.promptWarning = true
      }
    },
    closeDialog() {
      this.$emit('close')
    },
    closeWarningDialog() {
      this.promptWarning = false
    },
    assignDocNoInfo(data) {
      this.matchLaterForm.docNo = data.branch + ' ' + data.tranType + ' ' + data.docNo + ' ' + data.fund + ' ' + data.acctNoSfx
      this.matchLaterForm.bmDocNo = data.docNo
      this.matchLaterForm.bmBrn = data.branch
      this.matchLaterForm.bmTranType = data.tranType
      this.matchLaterForm.bmFund = data.fund
      this.matchLaterForm.bmAcctNoSfx = data.acctNoSfx
      this.matchLaterForm.bmAcctNo = data.acctNo
    },
    assignCoverNoteInfo(data) {
      this.matchLaterForm.coverNote = data.cnNo
    },
    assignVehRegInfo(data) {
      this.matchLaterForm.vehRegNo = data.vehRegNo
    },
    assignPoNoInfo(data) {
      this.matchLaterForm.polNo = data.policyNo + '-' + data.renCnt + '-' + data.endtCnt
      this.matchLaterForm.companyName = data.fullName
      this.matchLaterForm.docAddress1 = data.address1
      this.matchLaterForm.docAddress2 = data.address2
      this.matchLaterForm.docAddress3 = data.address3
      this.matchLaterForm.docAddress4 = data.address4
      this.matchLaterForm.postalCode = data.postalCode
      this.matchLaterForm.insuredName = data.insuredName
      this.matchLaterForm.insdRefNo = data.insdRefNo
    }
  },
  computed: {
    checkPolicy() {
      if (this.matchLaterForm.polNo !== '') {
        return 'entry|checkPolicyNo:' + this.matchLaterForm.polNo
      } else {
        return ''
      }
    }
  },
  created() {
    this.$validator.extend('checkPolicyNo', {
      getMessage(field, args) {
        return 'Invalid policy no. format. E.g: Policy No-RenCnt-EndtCnt'
      },
      validate(value, args) {
        let polNo = value.split('-')[0]
        let renCnt = value.split('-')[1]
        let endtCnt = value.split('-')[2]
        if (polNo !== undefined && renCnt !== undefined && endtCnt !== undefined) {
        } else {
          return false
        }
        return true
      }
    })
  },
  watch: {
    boolRefresh: function (value) {
      if (value) {
        this.doInit()
      }
    }
  },
  mixins: [commonAjaxMixin],
  components: {
    DocNoHelpList,
    CoverNoteHelpList,
    VehRegHelpList,
    AcctPolicyHelpList
  },
  props: {
    boolRefresh: Boolean,
    multiFundSfxCurr: Boolean,
    tranType: String,
    curr: String,
    acctNo: String,
    fund: String,
    acctNoSfx: String,
    polNo: String
  }
}
</script>
